import { ActionTypes } from "../constants/action-types";

export const nbHitsCount = (nbHitsCount) => {
    return {
      type: ActionTypes.NB_HITS_COUNT_DATA,
      payload: nbHitsCount,
    };
  };